import { Box, Text, Heading, Container } from "@chakra-ui/react";

const TerminosCondiciones = () => {
  return (
    <Container maxW="container.lg" py={10}>
      <Heading as="h1" size="xl" mb={6} textAlign="center">
        TÉRMINOS Y CONDICIONES
      </Heading>
      <Heading as="h2" size="lg" mb={4}>
        PORTAL DE PAGOS DE TOTOLAC
      </Heading>
      <Text mb={4}>
        El presente documento establece los Términos y Condiciones que regulan
        el uso del portal de pagos en línea del H. Ayuntamiento de Totolac,
        disponible en el sitio web portalpagos.totolac.gob.mx. Al acceder y
        utilizar este portal, el usuario acepta cumplir con los presentes
        términos y condiciones. En caso de no estar de acuerdo con ellos, se le
        solicita abstenerse de utilizar este servicio.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Registro y uso del portal
      </Heading>
      <Text mb={4}>
        Para acceder a los servicios del portal, el usuario deberá proporcionar
        información personal verídica y vigente. Dicha información será tratada
        con estricta confidencialidad y se utilizará exclusivamente para fines
        relacionados con el proceso de pago. El usuario es responsable de la
        confidencialidad de sus credenciales de acceso y del uso indebido
        derivado de negligencia o descuido en su resguardo.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Procesamiento de pagos
      </Heading>
      <Text mb={4}>
        Las transacciones realizadas a través del portal se gestionan mediante
        la pasarela Openpay, la cual cumple con los más altos estándares
        internacionales de seguridad y protección de datos financieros (PCI-DSS).
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Comprobantes y facturación
      </Heading>
      <Text mb={4}>
        El sistema generará un comprobante electrónico como constancia de la
        transacción, el cual deberá ser descargado y conservado por el usuario
        como respaldo de su pago.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Política de reembolsos y cancelaciones
      </Heading>
      <Text mb={4}>
        Una vez completado el pago, no se aceptarán cancelaciones ni reembolsos,
        salvo en casos excepcionales y debidamente justificados.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Seguridad y privacidad
      </Heading>
      <Text mb={4}>
        La información proporcionada por los usuarios se manejará conforme a la
        Ley de Protección de Datos Personales en Posesión de Sujetos Obligados
        del Estado de Tlaxcala.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Responsabilidad
      </Heading>
      <Text mb={4}>
        El Ayuntamiento de Totolac no será responsable por interrupciones en el
        servicio derivadas de problemas técnicos ajenos al portal o a Openpay.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Modificaciones a los términos y condiciones
      </Heading>
      <Text mb={4}>
        El Ayuntamiento de Totolac se reserva el derecho de modificar los
        presentes Términos y Condiciones en cualquier momento.
      </Text>
      <Heading as="h3" size="md" mb={3}>
        Contacto
      </Heading>
      <Text mb={4}>
        Para cualquier duda, aclaración o sugerencia respecto a este portal,
        puede comunicarse al teléfono 246 328 0933 del Ayuntamiento de Totolac,
        enviar un correo electrónico a ayuntamientotolacdigital@gmail.com o
        acudir directamente a las oficinas en: Tepetlapa y Nieves, 90160 San Juan
        Totolac, Tlax.
      </Text>
      <Text fontSize="sm" color="gray.500">
        Fecha de última actualización: 11 de marzo 2025
      </Text>
    </Container>
  );
};

export default TerminosCondiciones;
